export const LOADER_STATUS = 'gstr/LOADER_STATUS';
export const SUPPLIER_INFO = 'gstr/SUPPLIER_INFO';
export const SUPPLIER_TRACK_RETURN = 'gstr/SUPPLIER_TRACK_RETURN';

